import { Component, ChangeDetectionStrategy, HostBinding, Input } from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-key-value-list",
    templateUrl: "./sps-key-value-list.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsKeyValueListComponent {
    static readonly displayName = "sps-key-value-list";
    static readonly props = {
        inline: "boolean",
    };

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-key-value-list--inline")
    inline: boolean;

    @HostBinding("class.sps-key-value-list") readonly _spsKeyValueListClass = true;
}
